'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _collectInfoModal = require('./collect-info-modal');

var _collectInfoModal2 = _interopRequireDefault(_collectInfoModal);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CollectInfo = function (_Component) {
    _inherits(CollectInfo, _Component);

    function CollectInfo(props) {
        _classCallCheck(this, CollectInfo);

        var _this = _possibleConstructorReturn(this, (CollectInfo.__proto__ || Object.getPrototypeOf(CollectInfo)).call(this, props));

        _this.state = { show: true };
        _this.hide = _this.hide.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        return _this;
    }

    _createClass(CollectInfo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _logger2['default'].track('CollectInfoModal.loaded');
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.setState({
                show: false
            });
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess() {
            this.hide();
            if (this.props.shouldExplainAfterClose) {
                var redirect = '/home/chooseSignMethod?explain=1';
                if (this.props.isEnterprise) {
                    redirect += '&enterprise=1';
                }
                window.location = redirect;
            }
        }
    }, {
        key: 'render',
        value: function render() {

            var modal = void 0;
            if (this.state.show) {
                modal = _react2['default'].createElement(_collectInfoModal2['default'], _extends({}, this.props, { onSuccess: this.onSuccess }));
            }

            return _react2['default'].createElement(
                'div',
                { className: 'm-collect-info' },
                modal
            );
        }
    }]);

    return CollectInfo;
}(_react.Component);

module.exports = CollectInfo;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/collect-info/index.jsx
 ** module id = 1186
 ** module chunks = 0 1
 **/